import { getCountryDataList, getEmojiFlag } from 'countries-list';

export interface CountryCodeItem {
  name: string;
  code: string;
  flag: string;
}

export const countryCodes: CountryCodeItem[] = getCountryDataList()
  .map((country) => ({
    name: country.name,
    code: `+${country.phone[0] || ''}`,
    flag: getEmojiFlag(country.iso2),
  }))
  // Filter out any entries that might not have a valid phone code
  .filter((item) => item.code !== '+')
  // Sort alphabetically by name
  .sort((a, b) => a.name.localeCompare(b.name));
